/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Select_PromptInputs */

const cs_chat_select_prompt = /** @type {(inputs: Chat_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte konverzaci nebo založte novou.`)
};

const en_chat_select_prompt = /** @type {(inputs: Chat_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a conversation or start a new one.`)
};

/**
* | output |
* | --- |
* | "Select a conversation or start a new one." |
*
* @param {Chat_Select_PromptInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_select_prompt = /** @type {((inputs?: Chat_Select_PromptInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Select_PromptInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_select_prompt(inputs)
	return cs_chat_select_prompt(inputs)
});